/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from 'styled-components'
import { Input } from 'reactstrap'

const InputCustom = styled(Input)`
  border-radius: 0;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: none;
  border-radius: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out;
  margin-bottom: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  .form-control-file {
    color: #555;
  }
  &::placeholder {
    color: #555;
  }
  option {
    font-size: 16px;
    line-height: 1.42857143;
    color: #000;
  }
`

export default function Btn({ children, ...props }) {
  return (
    <>
      <InputCustom {...props}>{children && children}</InputCustom>
    </>
  )
}
